import { FC, useState } from 'react';
import { Table, Typography } from 'antd';
import i18n from 'i18next';
import { isMobileOnly } from 'react-device-detect';

import {RejectedMessage, TableWrapper} from 'componets/ui';
import { MyInvestmentsFilters } from '../MyInvestmentsFilters';

import {
	downloadFinishedInvestments,
	getMyFinishedInvestments,
} from 'features/myInvestments/actions';

import { useAppSelector, useMyInvestmentTable } from 'hooks';

import { ColumnTypes, FieldData } from 'models';

import { PAGE_SIZE, RequestStatus } from 'utils/constants';

import { columnsTable, receivedPaymentColumns, soldColumn } from '../columnsTable';

const columns = [
	...columnsTable,
	{
		title: i18n.t('termText'),
		dataIndex: 'term',
		sorter: true,
		defaultSortOrder: '',
		width: 80,
		textWrap: 'word-break',
		render: (term: number) => {
			const isPositive = term >= 0;
			const textDays = term === 1 ? 'dayText' : 'daysText';

			const textTerm = isPositive
				? `${term}  ${i18n.t(textDays)}`
				: i18n.t('daysLateProjectText', { item: Math.abs(term), textDays });

			return <Typography.Text>{textTerm}</Typography.Text>;
		},
	},

	{
		title: i18n.t('finalPaymentDateText'),
		dataIndex: 'finishedAt',
		defaultSortOrder: 'descend',
		sorter: true,
		width: 135,
		textWrap: 'word-break',
	},
	...receivedPaymentColumns,
	soldColumn,
];

type FinishedLoansProps = { initialValues: any; form: any; values: any; type: string };

export const FinishedLoans: FC<FinishedLoansProps> = ({ initialValues, form, values, type }) => {
	const {
		myInvestments,
		pager,
		status: requestStatus,
	} = useAppSelector((state) => state.myInvestments);

	const { page, onDownload, onChange } = useMyInvestmentTable({
		values,
		initialValueSort: '-finishedAt',
		isGet: type === 'finished',
		downloadCallback: downloadFinishedInvestments,
		getCallback: getMyFinishedInvestments,
	});

	const [fields, setFields] = useState<FieldData[]>([]);

	const isPending = requestStatus === RequestStatus.PENDING;

	return (
		<div>
			<MyInvestmentsFilters
				length={myInvestments.length}
				onDownload={onDownload}
				form={form}
				fields={fields}
				setFields={setFields}
				initialValues={initialValues}
				values={values}
			/>

			{requestStatus === RequestStatus.REJECTED ? (
				<RejectedMessage />
			) : (
				<TableWrapper data={myInvestments} loading={isPending && myInvestments.length === 0}>
					<Table
						loading={isPending}
						onChange={onChange}
						className="accountTable myInvestmentsTable"
						scroll={{ x: 1600 }}
						columns={columns as ColumnTypes}
						dataSource={myInvestments}
						showSorterTooltip={false}
						pagination={{
							current: page,
							defaultPageSize: PAGE_SIZE,
							total: pager.totalCount,
							showSizeChanger: false,
							position: isMobileOnly ? ['bottomCenter'] : ['bottomRight'],
							hideOnSinglePage: true,
							showLessItems: true,
						}}
						sortDirections={['ascend', 'descend', 'ascend']}
					/>
				</TableWrapper>
			)}
		</div>
	);
};
